import '../App.css';
import { Link } from 'react-router-dom';
import Layout from "../components/Layout";

function Leaderboard() {
  return (
    <Layout>
        <h1 className="section-title">Canopy Champions</h1>

        <div className="board-card anim-pop">
            <div className="board-head">
                <span>Rank</span>
                <span>Monkey</span>
                <span>Bananas</span>
            </div>

            <div className="board-empty">
                <span className="menu-icon" style={{ background: "var(--banana)" }}>🍌</span>
                <p>No scores hanging here yet.</p>
                <p>Play a round and your name could be top of the tree.</p>
            </div>

            <div className="btn-row">
                <Link className="btn" to="/play">Grab the First Spot</Link>
            </div>
        </div>

        <Link className="btn btn-leaf" to="/">Back to the Treehouse</Link>
    </Layout>
  );
}

export default Leaderboard;
